<template>
    <div class="pipeParamSet">
       <el-form ref="form" label-width="100px" class="attr_common" label-position="left" :inline="true" v-if="curSuggestion">
           <el-form-item label="方案名称:">
                <el-input v-model="curSuggestion.name" class="input-box" :disabled="!updateFlag"></el-input>
            </el-form-item>
            
           <el-form-item label="管材类型:">
                <el-select v-model="curSuggestion.pipeMaterial" placeholder="请选择" class="input-box" value-key="id" :disabled="!updateFlag">
                    <el-option
                        v-for="item in pipeTypes"
                        :key="item.id"
                        :label="item.name"
                        :value="item">
                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="绝对粗糙度:">
                <el-input v-model="curSuggestion.absRough" class="input-box" :disabled="!updateFlag"></el-input>
                <span class="attr_unit">mm</span>
            </el-form-item>
            <el-form-item label="黑度:">
                <el-input v-model="curSuggestion.blackness" class="input-box" :disabled="!updateFlag"></el-input>
            </el-form-item>
            <el-form-item label="管道导热系数:">
                <el-input v-model="curSuggestion.pipeThermConduct" class="input-box" :disabled="!updateFlag"></el-input>
                <span class="attr_unit">w/(m·℃)</span>
            </el-form-item>
        </el-form>

        <!--地埋方案设置-->
        <el-table
            :data="suggestions"
            border
            style="width: 100%"
            class="custom-table"
            max-height="300"
            highlight-current-row
            row-class-name="custom-row"
            cell-class-name="custom-cell"
            header-row-class-name="custom-header"
            @current-change="suggestionChange"
            ref="suggestionsTable">

            <el-table-column
                prop="id"
                width="50"
                label="编号">
            </el-table-column>
            <el-table-column
                prop="name"
                label="方案名称">
            </el-table-column>
            <el-table-column
                prop="pipeMaterial"
                label="材料">
            </el-table-column>
            <el-table-column
                prop="absRough"
                label="绝对粗糙度">
            </el-table-column>
            <el-table-column
                prop="blackness"
                label="黑度">
            </el-table-column>
            <el-table-column
                prop="pipeThermConduct"
                label="管道导热系数">
            </el-table-column>
            <el-table-column
                fixed="right"
                label="操作"
                width="100">
                <template slot-scope="scope">
                    <el-button @click="defaultSuggestion(scope.row)" type="text" size="small" v-if="defaultSug.id!=scope.row.id">设为默认</el-button>
                    <span v-else>默认</span>
                </template>
            </el-table-column>
        </el-table>

        <div class="foot-btn">
            <el-button size="medium" type="primary" @click="addSuggestion" v-if="!updateFlag">新增</el-button>
            <el-button size="medium" type="primary" @click="updateSuggestion" v-if="!updateFlag">修改</el-button>
            <el-button size="medium" type="primary" @click="deleteSuggestion" v-if="!updateFlag&&this.suggestions.length>1">删除</el-button>
            <el-button size="medium" type="primary" @click="saveSuggestion" v-if="updateFlag">保存</el-button>
            <el-button size="medium" type="primary" @click="cancelSuggestion" v-if="updateFlag">取消</el-button>
        </div>
    </div>
</template>

<script>
import _remove from "lodash/remove";
import _find from "lodash/find";

export default {
    name:"overHeadParamSet",
    computed:{
        // 全局配置
        globalConfig(){
            return this.$store.state.simulation.globalConfig;
        }
    },
    data(){
        return {
            defaultSug:{}, // 默认方案
            curSuggestion:{
                id:0,
                name:"默认方案",
                pipeMaterial:"20#钢管", // 管材类型
                absRough:0.0546, // 绝对粗糙度
                blackness:0.23, // 黑度
                pipeThermConduct:38.65, // 管道导热系数
            } , // 当前属性

            pipeTypes:[{
                id:0,
                name:"20#钢管",
            },
            {
                id:1,
                name:"合金钢管",
            }], // 管材类型

            suggestions:[{
                id:1,
                name:"默认方案",
                pipeMaterial:"20#钢管", // 管材类型
                absRough:0.0546, // 绝对粗糙度
                blackness:0.23, // 黑度
                pipeThermConduct:38.65, // 管道导热系数
            }], // 可选方案列表

            updateFlag:false, // 是否可以编辑
        }
    },
    mounted(){
        this.init_data();
    },
    methods:{
        // 初始化数据
        init_data(){
            if(this.globalConfig){
                // 方案列表
                if(this.globalConfig.pipeParamSugs){
                    this.suggestions=JSON.parse(JSON.stringify(this.globalConfig.pipeParamSugs));
                }
                // 当前方案
                if(this.globalConfig.pipeModel.pipeParam){
                    this.defaultSug=this.globalConfig.pipeModel.pipeParam; // 默认方案
                    this.curSuggestion=JSON.parse(JSON.stringify(this.defaultSug));
                }

            }
        },
        // 新增
        addSuggestion(){
            let suglength=this.suggestions.length;
            let id=this.suggestions[suglength-1].id+1;
            this.curSuggestion={
                id:id,
                name:"默认材料"+id, // 保温材料名称
                pipeMaterial:"20#钢管", // 管材类型
                absRough:0.0546, // 绝对粗糙度
                blackness:0.23, // 黑度
                pipeThermConduct:38.65, // 管道导热系数
            }
            this.updateFlag=true;
        },
        // 更新
        updateSuggestion(){
            this.updateFlag=true;
        },
        // 取消保存
        cancelSuggestion(){
            let currentId=this.curSuggestion.id;
            let temp=_find(this.suggestions, function(o) { return o.id == currentId; });
            if(!temp){
                temp=this.suggestions[0];
            }
            this.curSuggestion=JSON.parse(JSON.stringify(temp));
            this.updateFlag=false;
        },

        // 保存方案
        saveSuggestion(){
            let temp=null;
            this.suggestions.forEach((item,index)=>{
                if(item.id == this.curSuggestion.id){
                    item=JSON.parse(JSON.stringify(this.curSuggestion));
                    temp=item;
                    this.$set(this.suggestions,index,item); // 更新表格
                }
            });
            // 如果存在该类型的材料，则更新，否则新增
            if(!temp){
                temp=JSON.parse(JSON.stringify(this.curSuggestion));
                this.suggestions.push(temp);
            }
            // 关闭修改
            this.updateFlag=false;

            // 设置选中
            this.$refs.suggestionsTable.setCurrentRow(temp);

            // 触发父元素数组更新
            this.globalSuggestionChange();
            // 弹出提示框，提示保存成功
            this.$message({
                message:"保存成功",
                type:"success",
                duration:2000
            });
        },
        // 方案选中改变
        suggestionChange(item){
            item=item||this.suggestions[0];
            this.curSuggestion=JSON.parse(JSON.stringify(item));
        },
        // 删除方案
        deleteSuggestion(){
            let id=this.curSuggestion.id;
            this.suggestions=_remove(this.suggestions, function(it) {  return it.id!=id;});
            // 恢复默认
            this.curSuggestion=JSON.parse(JSON.stringify(this.suggestions[0]));
            // 设置选中
            this.$refs.suggestionsTable.setCurrentRow(this.suggestions[0]);
            // 停止更新
            this.updateFlag=false;
        },
        // 设为默认方案
        defaultSuggestion(item){
            let temp=JSON.parse(JSON.stringify(this.globalConfig));
            this.defaultSug=item;
            temp.pipeModel.pipeParam=item;
            this.$store.commit("simulation/setGlobalConfig",temp);
            // 后台保存用户配置
            this.$store.dispatch("simulation/saveGlobalConfig",temp);
        },
        // 全局方案修改
        globalSuggestionChange(){
            let temp=JSON.parse(JSON.stringify(this.globalConfig));
            temp.pipeParamSugs=this.suggestions;
            this.$store.commit("simulation/setGlobalConfig",temp);
            // 后台保存用户配置
            this.$store.dispatch("simulation/saveGlobalConfig",temp);
        }
    }
}
</script>

<style lang="scss" scoped>
.pipeParamSet{
    width: 600px!important;

    .attr_common{
        display: flex;
        flex-wrap: wrap;

        ::v-deep .el-form-item{
            width: 50%;
            margin-right: 0;

            .el-input{
                width: 120px;
            }
        }
    }

    .foot-btn{
        margin-top: 10px;
    }
}
</style>